import { AirplaneTilt, ArrowClockwise, ArrowRight, ArrowsCounterClockwise, ArrowSquareOut, ArrowUDownLeft, Bell, BracketsCurly, Calendar, CalendarBlank, Camera, Car, CaretDown, CaretLeft, CaretRight, CaretUp, Check, CheckCircle, Circle, CircleHalf, Clipboard, Clock, CloudArrowUp, Copy, CopySimple, DownloadSimple, Envelope, EnvelopeSimple, FacebookLogo, FileDashed, FileDoc, FileImage, FilePdf, FileX, FileXls, FloppyDisk, Funnel, Gear, GearSix, Globe, Hourglass, IconWeight, Info, Layout, Link, LinkSimpleBreak, List, ListBullets, ListChecks, Lock, MagicWand, MagnifyingGlass, Moon, MusicNotes, PencilSimple, Phone, Plus, Question, Sidebar, SignOut, Sparkle, SpinnerGap, SquaresFour, Star, Student, Sun, Swap, TextIndent, Train, Trash, UserGear, UsersThree, Warning, WarningCircle, X } from "@phosphor-icons/react";
import React from "react";

export interface PhosphorIconProps {
  className?: string
  iconSize?: "small" | "regular" | "large"
  iconColor?: "gray" | "primary" | "white" | "error" | "yellow" | "green";
  iconWeight?: IconWeight;
}

export const PhosphorBell = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Bell size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorCamera = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Camera size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorCaretDown = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <CaretDown size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorCaretLeft = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <CaretLeft size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorCaretRight = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <CaretRight size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorCaretUp = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <CaretUp size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorCheck = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Check size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorCheckCircle = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <CheckCircle size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
}

export const PhosphorCircle = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Circle size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorCircleHalf = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <CircleHalf size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorCalendar = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Calendar size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorClock = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Clock size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorCopy = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Copy size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
}

export const PhosphorCopySimple = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <CopySimple size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
}

export const PhosphorClipboard = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Clipboard size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
}

export const PhosphorArrowUp = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <CloudArrowUp size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhopshorArrowRight = (props: PhosphorIconProps) => {
  return <IconWrapper {...props}>
    <ArrowRight size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>
}

export const PhosphorArrowUDownLeft = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <ArrowUDownLeft size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
}

export const PhosphorBracketsCurly = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <BracketsCurly size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
}

export const PhosphorDownloadSimple = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <DownloadSimple size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorEnvelope = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Envelope size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorEnvelopeSimple = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <EnvelopeSimple size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorFacebookLogo = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <FacebookLogo size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorFileDashed = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <FileDashed size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorFileX = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <FileX size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
}

export const PhosphorFileImage = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <FileImage size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
}

export const PhosphorFilePdf = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <FilePdf size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorFileDocx = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <FileDoc size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorFileXlsx = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <FileXls size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorFloppy = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <FloppyDisk size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorFunnel = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Funnel size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorGear = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Gear size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorGearSix = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <GearSix size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorGlobe = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Globe size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorPlus = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Plus size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
}

export const PhosphorHourglass = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Hourglass size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorInfo = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Info size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorLink = (props: PhosphorIconProps) => {
  const weight = props.iconWeight ? props.iconWeight : "bold";

  return (<IconWrapper {...props}  >
    <Link size={GetSize(props.iconSize)} color={GetColor(props)} weight={weight} />
  </IconWrapper>)
};

export const PhosphorLinkBreak = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}  >
    <LinkSimpleBreak size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorList = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <List size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorListChecks = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <ListChecks size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorListBullets = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <ListBullets size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorMagnifyingGlass = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <MagnifyingGlass size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorMoon = (props: PhosphorIconProps) => {
  const weight = props.iconWeight ? props.iconWeight : "fill";

  return (<IconWrapper {...props}>
    <Moon size={GetSize(props.iconSize)} color={GetColor(props)} weight={weight} />
  </IconWrapper>)
};

export const PhosphorPencil = (props: PhosphorIconProps) => {

  return (<IconWrapper {...props}>
    <PencilSimple size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorPhone = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Phone size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorQuestion = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Question size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorSidebar = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Sidebar size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorSignOut = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <SignOut size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

// Spins by itself, see .phosphor-spinner in phosphor-icon.scss
export const PhosphorSpinner = (props: PhosphorIconProps) => {
  return <span className="phosphor-spinner">
    <SpinnerGap size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </span>
}

export const PhosphorSquaresFour = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <SquaresFour size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorSun = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Sun size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorStar = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Star size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorSparkle = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Sparkle size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
}

export const PhosphorMagicWand = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <MagicWand size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
}

export const PhosphorStudent = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Student size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
}

export const PhosphorTextIndent = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <TextIndent size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorTrash = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Trash size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorUserGear = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <UserGear size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorWarningInline = () => {
  return <span style={{
    display: "inline-block",
    verticalAlign: "bottom",
    height: 18,
  }} className="margin-right-small">
    <PhosphorWarning />
  </span>
}

export const PhosphorWarning = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Warning size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorWarningCircle = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <WarningCircle size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorX = (props: PhosphorIconProps) => {

  const weight = props.iconWeight ? props.iconWeight : "bold";

  return (<IconWrapper {...props}>
    <X size={GetSize(props.iconSize)} color={GetColor(props)} weight={weight} />
  </IconWrapper>)
};

export const PhosphorSwap = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Swap size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
}

export const PhosphorRefresh = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <ArrowsCounterClockwise size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
}

export const PhosphorArrowClockwise = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <ArrowClockwise size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
}

export const PhosphorArrowSquareOut = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <ArrowSquareOut size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
}

export const PhosphorLayout = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Layout size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
}

export const PhosphorAirplaneTilt = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <AirplaneTilt size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorCalendarBlank = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <CalendarBlank size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorCar = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Car size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorLock = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Lock size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorMusicNotes = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <MusicNotes size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorTrain = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <Train size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

export const PhosphorUsersThree = (props: PhosphorIconProps) => {
  return (<IconWrapper {...props}>
    <UsersThree size={GetSize(props.iconSize)} color={GetColor(props)} weight={props.iconWeight} />
  </IconWrapper>)
};

interface IconWrapperProps extends PhosphorIconProps {
  children: React.ReactNode;
}

const IconWrapper: React.FC<IconWrapperProps> = ({ children }) => {
  return <span>
    {children}
  </span>
};

const GetColor = (props: PhosphorIconProps) => {
  switch (props.iconColor) {
    case "gray":
      return "var(--text-color-lighter)";
    case "white":
      return "white";
    case "primary":
      return "var(--primary-color)";
    case "error":
      return "var(--text-color-error)";
    case "yellow":
      return "var(--yellow)";
    case "green":
      return "var(--green)";
    default:
      return null;
  }
}

const GetSize = (size: string) => {
  switch (size) {
    case "small":
      return 14;
    case "large":
      return 24;
    case "regular":
    default:
      return 18;
  }
}

export const PhosphorIconForFileUpload = ({ type, error }: { type: "image" | "file" | "docx" | "pdf"; error: boolean; }) => {
  const iconColor = error ? "error" : "primary";

  switch (type) {
    case "image":
      return <PhosphorFileImage iconSize="large" iconColor={iconColor} />
    case "file":
      return <PhosphorFileDashed iconSize="large" iconColor={iconColor} />
    case "docx":
      return <PhosphorFileDocx iconSize="large" iconColor={iconColor} />
    case "pdf":
      return <PhosphorFilePdf iconSize="large" iconColor={iconColor} />
    default:
      return <PhosphorFileDashed iconSize="large" iconColor={iconColor} />
  }
}

export const PhosphorIconForExportOption = ({ type }: { type: server.dto.ExportType }) => {

  if (type.action === "store") return PhosphorArrowUp({});

  switch (type.extension) {
    case "docx":
      return PhosphorFileDocx({});
    case "pdf":
      return PhosphorFilePdf({});
    case "xlsx":
      return PhosphorFileXlsx({});
    default:
      return PhosphorFileDashed({});
  }
};